import {
  TSemanticButtonVariant,
} from './semantic-button';

type TSemanticButtonLabelMap = Record<TSemanticButtonVariant, string>;

const polish: TSemanticButtonLabelMap = {
  accept: 'Akceptuj',
  add: 'Dodaj',
  back: 'Wstecz',
  cancel: 'Anuluj',
  close: 'Zamknij',
  create: 'Utwórz',
  delete: 'Usuń',
  edit: 'Edytuj',
  forward: 'Dalej',
  reset: 'Resetuj',
  resetFilters: 'Resetuj filtry',
  save: 'Zapisz',
  saveAsNew: 'Zapisz jako ...',
  settings: 'Ustawienia',
  tableNavigation: '',
  upload: 'Prześlij',
  calculate: 'Oblicz',
  revision: 'Poprawka',
  fullscreen: 'Pełny ekran',
  optionMenu: 'Dodatkowe funkcje',
  duplicate: 'Duplikuj',
  refresh: 'Odśwież',
  copy: 'Kopiuj',
  download: 'Pobierz',
  moveUp: 'Przesuń w górę',
  moveDown: 'Przesuń w dół',
};

export default polish;
